import { DatabaseInfo, OnlineStorage } from "@tblabs/storage";
import { TableBuilder, Button, Snack, Collection } from "@tblabs/truffle";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { LogViewer } from "../Components/LogViewer";
import { Page } from "./Page";
import { DangerButton } from "../Components/DangerButton";
import { Bold } from "../Components/Bold";


export class AllDatabasesPage extends Page
{
    private databasesCollection = new Collection<DatabaseInfo>();

    constructor(private _storage: OnlineStorage)
    {
        super("Databases Admin panel");

        this.Content(async () =>
        {
            const databases: DatabaseInfo[] = await this._storage.ListDatabases();
            this.databasesCollection.Load(...databases);
            const users = await this._storage.ListUsers();

            this.body.Append(
                new Panel(["All databases on ", new Bold(_storage.Server), " (", this.databasesCollection.Count, ")"], [
                    new TableBuilder(this.databasesCollection)
                        .AddColumn("Database", x => x.Dir)
                        .AddColumn("Datasets", x => x.DatasetsCount)
                        .AddColumn("Users", x => x.UsersCount)
                        .AddColumn("Options", x => [
                            new Button("Login to").OnClick(() => window.location.hash = `login/${x.Dir}/admin/admin`),
                            new DangerButton("Delete").OnClick(async () => await this.DeleteDatabase(x)).MarginLeft(12)
                        ])
                        .Build(),
                    new PrimaryButton("Add Database").OnClick(() => window.location.hash = `admin/databases/add`)
                ]),
                new Panel(["Users of ", new Bold(_storage.DatabaseDir), " database (", users.length, ")"], [
                    new TableBuilder(users)
                        .AddColumn("Name", x => x.Icon + " " + x.Name)
                        .AddColumn("Role", x => x.Role)
                        .AddColumn("Options", x => new Button("OPEN").OnClick(() => window.location.hash = `admin/user/${x.Id}`))
                        .Build(),
                    new PrimaryButton("Add User").OnClick(() => window.location.hash = `admin/user/add`)
                ]),
                new Panel("Logs", [
                    new LogViewer(this._storage),
                ])
            );
        });
    }

    private async DeleteDatabase(database: DatabaseInfo)
    {
        if (confirm(`Are you sure you want to delete ${database.Dir} database?`))
        {
            await this._storage.DeleteDatabase(database.Dir);
            this.databasesCollection.Remove(database);
            new Snack("✅ Database deleted");
            window.location.hash = `admin/databases`;
        }
    }
}
